const createProgressHandler = onUploadProgress => progressEvent => {
  const complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
  if (onUploadProgress) {
    onUploadProgress(complete)
  }
}

const S3_UPLOAD_URL = '/aws/v1frontend/file/upload'
const MIME_EXT_MAP = {
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/png': 'png',
  'application/pdf': 'pdf',
  'application/zip': 'zip',
  'application/x-zip-compressed': 'zip',
}

function normalizeS3UploadResponse (res) {
  if (res && res.data && res.data.model) {
    return {
      ...res,
      data: res.data.model,
    }
  }

  return res
}

function createUploadOptions (onUploadProgress) {
  return {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: createProgressHandler(onUploadProgress),
  }
}

async function uploadToS3 (axios, formData, options) {
  const res = await axios.post(S3_UPLOAD_URL, formData, options)
  return normalizeS3UploadResponse(res)
}

function getUploadExt (file, policyParams) {
  if (policyParams.ext) {
    return policyParams.ext
  }
  if (file.name && file.name.indexOf('.') > -1) {
    return file.name.split('.').pop()
  }
  if (file.type) {
    return MIME_EXT_MAP[file.type] || file.type.split('/').pop()
  }
  return ''
}

function getUploadFileName (file, extName) {
  if (file.name) {
    return file.name
  }
  return extName ? `upload.${extName}` : 'upload'
}

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  delete ({ rootState }, params) {
    return rootState.axios.post('/upyun/upyun/delete', params)
  },
  generateFormPolicy ({ rootState }, params) {
    return rootState.axios.get('/upyun/upyun/generate-form-policy', { params })
  },
  async uploadImg ({ rootState }, {
    file,
    policyParams = {},
    onUploadProgress,
    noLimitName = false,
  }) {
    const reg = /[.](jpg|png|jpeg|pdf)$/i // 匹配圖片
    const fileName = file.name || ''
    if (!noLimitName) {
      if (!reg.test(fileName)) {
      // eslint-disable-next-line no-throw-literal
        throw fileName + '格式非法，請選擇jpg、png、jpeg類文件'
      }
    }
    // if (kbSize > 5120) {
    //   // eslint-disable-next-line no-throw-literal
    //   throw '請上傳小於5MB的圖片'
    // }
    // if (kbSize < 5) {
    //   // eslint-disable-next-line no-throw-literal
    //   throw '請上傳大於5kb的圖片'
    // }

    const extName = getUploadExt(file, policyParams)
    const formData = new FormData()
    formData.append('file', file, getUploadFileName(file, extName))
    formData.append('dir', policyParams.dir)
    return uploadToS3(rootState.axios, formData, createUploadOptions(onUploadProgress))
  },
  async uploadFile ({ rootState }, {
    formData,
    onUploadProgress
  }) {
    return uploadToS3(rootState.axios, formData, createUploadOptions(onUploadProgress))
  },
  serverUpload ({ rootState }, { formData, onUploadProgress }) {
    return uploadToS3(rootState.axios, formData, createUploadOptions(onUploadProgress))
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
